import { FEATURES } from '../../../../utils/ServiceUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { CustomView, toCustomView } from '../../dataObjects/CustomView';

export interface IUpdateCustomViewsRequest extends IBaseRequest {
    CUSTOM_VIEWS: CustomView[];
}

export class UpdateCustomViewsRequest extends BaseRequest implements IUpdateCustomViewsRequest {

  public CUSTOM_VIEWS: CustomView[];

  constructor(server: string, session: string, CUSTOM_VIEWS: CustomView[]) {
    super(server, session);
    this.CUSTOM_VIEWS = CUSTOM_VIEWS;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    if(this.CUSTOM_VIEWS) {
        for(let customView of this.CUSTOM_VIEWS) {
            parameters += toCustomView(customView);
        }
    }
    return super.wrapperXml(FEATURES.updateCustomViews, parameters);
  }
}
